import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import HeaderPartner from "./HeaderPartner";
import PageProgressBarPartner from "./PageProgressBarPartner";
import { useNavigate } from "react-router-dom";
import PageSideBar from "./PageSideBar";
import DigiDocumentList from "./DigiDocumentList";
import { toast } from "react-toastify";
import { decryptData } from "../CommonMethods/CommonMethods";
import axios from "axios";
import { Partner_Portal } from "../Configuration/API_URL";


const SelfieUpload = () => {
    const partnerToken = localStorage.getItem("partner_signup_token");
    const navigate = useNavigate();
    const [partnerData, setPartnerData] = useState("")

      const getSignupPartnerDetail = async () => {
    try {
      const getValues = await axios.get(
        Partner_Portal.CreatePartner_Url,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const signupResp = decryptData(getValues?.data);
      const decryptedData = JSON.parse(signupResp);
      if (decryptedData?.status === 0) {
        let partnerVal = decryptedData?.data?.info;
        setPartnerData(partnerVal);
        console.log(partnerVal, "partnerDataBank");

        localStorage.removeItem("showBankData")

        if(partnerVal?.isDigilocker === false){
            localStorage.setItem("manualUpload", true)
        } else{
            localStorage.setItem("manualUpload", false)
        }

      } else {
        toast.error(decryptedData?.data?.message);
      }
    } catch (error) {
      console.log(error);
        if(error?.response?.status === 500){
            toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
        }
        if(error?.request?.status === 401){
            localStorage.clear("");
            navigate("/partner");
        }
    }
    };

    useEffect(() => {
        getSignupPartnerDetail();
    }, []);


    return (
        <>
            <HeaderPartner />
            <PageProgressBarPartner progress="selfie-upload" partnerData={partnerData}/>

            <main className="main-content page-wrapper partner-page partner-page-postlogin">
                <div className="h-md-100 ">
                    <Row className="h-md-100 p-0 m-0 mobile-view">
                        <Col lg={6} className="p-0">
                            <PageSideBar />
                        </Col>
                        <Col lg={6} className="p-0">
                            {/* <div className="page-header right-box">
                                 {console.log(manualSelect, "manualSelect")}
                                     {manualSelect === false &&
                                    <div className="wrap-all doc-upload">

                                        <div className="page-left landing-page viewheight">
                                            <img
                                                alt="prev-btn"
                                                className="previous-btn"
                                                src={previosPageArrow}
                                                href="previous page btn"
                                                onClick={previousBtn}
                                            />
                                            <div>
                                                <h2 className="page-title">
                                                    Confirm Selfie
                                                </h2>
                                                <h3 className="page-subtitle partner-subtitle">
                                                    Make sure your face is clearly visible
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                     }
                            </div> */}

                            {/* {manualSelect === true && <DigiDocumentList uploadSelfie={true} />} */}

                            <DigiDocumentList uploadSelfie={true}/>
                        </Col>
                    </Row>
                </div>
            </main>
            {/* <div className="congo-modal">
                <Modal
                    show={modalShow}
                    // onHide={onHide}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="ifscModal confirmation-modal"
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Body>
                        <img className="thumb-img" src={thumbIcon} alt="thumb icon" />
                        <form className="modal-form select-new">
                            <div className="form-group conf-modal">
                                <label htmlFor="bank-text" className="modal-heading">
                                    That’s Great! Your application is sent for review!
                                </label>
                                <span className="text-content">
                                    Once the verification is complete, we will notify you via
                                    email. Keep checking your inbox for the update!
                                </span>
                            </div>
                        </form>

                        <div className="text-center confirmation-button">
                            <button
                                className="common-btn conf-btn"
                                type="submit"
                                onClick={handleOk}
                            >
                                Okay
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div> */}
        </>

    );
};
export default SelfieUpload;
